import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "blog",
  class: "blog-wrap pb-75"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = { class: "blog-card style8" }
const _hoisted_5 = { class: "blog-img" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "blog-date" }
const _hoisted_8 = { class: "blog-info" }
const _hoisted_9 = { class: "blog-metainfo list-style" }
const _hoisted_10 = { href: "#" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "row" }, [
        _createElementVNode("div", { class: "col-lg-8 offset-lg-2" }, [
          _createElementVNode("div", { class: "section-title style1 text-center mb-40" }, [
            _createElementVNode("span", null, "Blog & News"),
            _createElementVNode("h2", null, "Read Our Latest News & Articles")
          ])
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blogs, (blog) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-xl-4 col-lg-6 col-md-6",
            key: blog.id
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: blog.image,
                  alt: "Image"
                }, null, 8, _hoisted_6),
                _createElementVNode("span", _hoisted_7, _toDisplayString(blog.date), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("ul", _hoisted_9, [
                  _createElementVNode("li", null, [
                    _cache[0] || (_cache[0] = _createElementVNode("i", { class: "ri-user-add-line" }, null, -1)),
                    _createElementVNode("a", _hoisted_10, _toDisplayString(blog.user), 1)
                  ]),
                  _cache[1] || (_cache[1] = _createElementVNode("li", null, [
                    _createElementVNode("i", { class: "ri-chat-4-line" }),
                    _createElementVNode("a", { href: "#" }, "No Comment")
                  ], -1))
                ]),
                _createElementVNode("h3", null, [
                  _createVNode(_component_router_link, { to: "/blog-details" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(blog.title), 1)
                    ]),
                    _: 2
                  }, 1024)
                ])
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}